import { MaskLine, Eyebrow, Reveal } from "./Reveal";

export function PageHeader({ eyebrow, title, body }) {
  return (
    <section className="border-b border-stone-900/10">
      <div className="mx-auto max-w-7xl px-4 pb-16 pt-20 sm:px-8 lg:px-16 lg:pb-24 lg:pt-28">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
        <h1 className="mt-6 max-w-4xl font-serif text-5xl font-light leading-[1.05] tracking-tight text-stone-900 sm:text-6xl lg:text-7xl">
          <MaskLine delay={0.1}>{title}</MaskLine>
        </h1>
        {body && (
          <Reveal delay={0.25}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-stone-600 sm:text-lg">{body}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
